import React from 'react';
import { Button, Classes, Dialog } from "@blueprintjs/core";
import Markdown from 'markdown-to-jsx';

export const AboutDialog = (props) => <Dialog
  className={'bp3-dark'}
  onClose={props.handleClose}
title="DUQE"
  isOpen={props.isOpen}
>
  <div className={Classes.DIALOG_BODY}>
    <p style={{fontStyle: 'italic'}}>
        A Lightweight Tool for Visualizing Treelike Data with Crosslinks. (Use the force, DUQE!)
    </p>
    <p><strong>Instructions</strong></p>
    <ul>
      <li>Use <code>tab</code> to nest items, just as if you were building a nested list.</li>
      <li>To draw crosslinks, write a pipe (|) delimited list of item names. Item names must be unique.</li>
      <li>To make items open web links in new tabs, include a URL as the third entry of your row. (Add example).</li>
      <li>To collapse tree sections, use the "-" icons to the left of each line</li>
      <li>For a full list of editor keyboard shortcuts, right click the editor and select the "Command Palette".</li>
      <li>The editor pane can be resized by dragging your mouse right side.</li>
      <li><Markdown>To load data from a remote URL, add `?graphData=` to the end of the URL, followed by a publicly accessible link with your data. [Example](/?graphData=https://gist.githubusercontent.com/hydrosquall/751d8a1462e2b57c6ff5258c4f3870aa/raw/c54c1c0f657db3331f0e6f470d831c1b216da795/testHierarchy.txt)</Markdown></li>
      <li>The force works in mysterious ways... stay tuned. Some are draggable, others are not.</li>
    </ul>
    <p><strong>Features</strong></p>
    <ul>
      <li>To collapse tree sections, use the "-" icons to the left of each line</li>
      <li>For a full list of keyboard shortcuts, right click the editor and select the "Command Palette". My favorite: put your cursor on a word that repeats, and press cmd + d.</li>
      <li>Your work is automatically saved offline, so your input will persist between page refreshes.</li>
      <li>The editor pane can be resized by dragging along the right edge of the pane.</li>
    </ul>
    <Markdown>
      This tool is a collaboration between Maxim Leyzerovich ([@round](https://twitter.com/@round)) and Cameron Yick ([@hydrosquall](https://twitter.com/@hydrosquall)).
    </Markdown>
    <hr/>
    <p>This project was enabled by multiple open-source technologies, especially</p>
    <ul>
      <li>Facebook React / Redux</li>
      <li><Markdown>Mike Bostock's [Tree-o-Matic](https://observablehq.com/@mbostock/tree-o-matic) and d3</Markdown></li>
      <li>Dom Moritz's React integration for Microsoft Monaco, and the design of the Vega Editor</li>
      <li>Palantir Blueprint</li>
    </ul>
  </div>
  <div className={Classes.DIALOG_FOOTER}>
    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
      <Button onClick={props.handleClose}>Close</Button>
    </div>
  </div>
</Dialog>;

export default AboutDialog;

// {/* <AnchorButton
//         intent={Intent.PRIMARY}
//         href="https://www.palantir.com/palantir-foundry/"
//         target="_blank"
//       >
//         Visit the Foundry website
//                             </AnchorButton> */}
